import { useState } from "react";
import { ArrowRight, Eye, EyeOff, Lock } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { api, getErrorMessage } from "@/api";

const logoUrl = "https://customer-assets-jt897jd0.emergentagent.net/job_artist-client-portal/artifacts/3z572eq9_ChatGPT%20Image%2029%20lug%202026%2C%2011_13_35.png";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    if (newPassword !== confirmPassword) {
      setError("Le due password non coincidono");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: newPassword });
      setSuccess(true);
    } catch (resetError) {
      setError(getErrorMessage(resetError));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page" data-testid="reset-password-page">
      <section className="login-art" data-testid="login-visual-panel">
        <div className="login-art-wave" aria-hidden="true" />
        <div className="login-brand"><img className="login-brand-logo" src={logoUrl} alt="Explosion Eventi" /></div>
        <div className="login-message">
          <p>GESTIONALE CREATIVO</p>
          <h1>Il ritmo del tuo lavoro,<br /><em>in un solo spazio.</em></h1>
        </div>
        <p className="login-footnote">DALL'IDEA ALL'EVENTO,<br />TUTTO SOTTO CONTROLLO.</p>
      </section>
      <section className="login-form-area">
        <div className="login-area-wave" aria-hidden="true" />
        <form className="login-form" onSubmit={handleSubmit} data-testid="reset-password-form">
          <img className="login-form-logo" src={logoUrl} alt="Explosion Eventi" />
          <div className="login-form-heading">
            <p className="eyebrow">NUOVA PASSWORD</p>
            <h2 data-testid="reset-password-title">Scegli una nuova password</h2>
          </div>
          {!token && <p className="form-error" data-testid="reset-password-missing-token">Link non valido: manca il token di reset. Richiedi un nuovo link dalla pagina di accesso.</p>}
          {success ? (
            <>
              <p className="form-hint" data-testid="reset-password-success">Password aggiornata con successo! Ora puoi accedere con la nuova password.</p>
              <button type="button" className="primary-button login-submit-button" data-testid="reset-password-go-to-login" onClick={() => navigate("/login")}>
                Vai al login<ArrowRight size={18} />
              </button>
            </>
          ) : (
            <>
              <label data-testid="reset-new-password-label">
                Nuova password
                <span className="login-input-icon-wrap">
                  <Lock size={17} className="login-input-icon" />
                  <input
                    data-testid="reset-new-password-input"
                    type={showPassword ? "text" : "password"}
                    placeholder="Almeno 10 caratteri"
                    value={newPassword}
                    onChange={(event) => setNewPassword(event.target.value)}
                    minLength={10}
                    required
                    style={{ paddingLeft: 40, paddingRight: 44 }}
                  />
                  <button
                    type="button"
                    className="login-password-toggle"
                    data-testid="reset-password-toggle"
                    onClick={() => setShowPassword((visible) => !visible)}
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </span>
              </label>
              <label data-testid="reset-confirm-password-label">
                Confermala nuova password
                <span className="login-input-icon-wrap">
                  <Lock size={17} className="login-input-icon" />
                  <input
                    data-testid="reset-confirm-password-input"
                    type={showPassword ? "text" : "password"}
                    placeholder="Ripeti la password"
                    value={confirmPassword}
                    onChange={(event) => setConfirmPassword(event.target.value)}
                    minLength={10}
                    required
                    style={{ paddingLeft: 40 }}
                  />
                </span>
              </label>
              {error && <p className="form-error" data-testid="reset-password-error">{error}</p>}
              <button data-testid="reset-password-submit-button" className="primary-button login-submit-button" disabled={loading || !token} type="submit">
                {loading ? "Aggiornamento in corso" : "Aggiorna password"}
                <ArrowRight size={18} />
              </button>
            </>
          )}
        </form>
      </section>
    </main>
  );
}
